import { IEnvironment } from '../models';
import { environment } from './environment';

export const environmentProd: IEnvironment = {
  ...environment,
  envName: 'production',
  chatbotApiUrl: 'https://immomio-ida-integration.meho.ai',
  production: true,
};
